import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, ValidatorFn, AbstractControl, ValidationErrors, 
  /*NgForm*/ } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from '../../../environments/environment';
import { ShareDataServiceService } from '../../services/share-data-service.service';
import { Tender } from 'src/app/models/Tender.class';
import { SelectTenderEventProps } from 'src/app/models/SelectTenderEventProps.class';
import { animate, style, transition, trigger } from '@angular/animations';

//https://dev.to/rodrigokamada/adding-the-google-recaptcha-v3-to-an-angular-application-kge

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    ),
    trigger(
      'leaveAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0, left:1}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1, left:0}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class RegistrationComponent implements OnInit {

  getFromNavigaionState(key:string):any{
    const nav = this.router.getCurrentNavigation() || (this.router as any).lastSuccessfulNavigation;;
    if(!nav || !nav.extras || !nav.extras.state || !nav.extras.state[key])
      return null;
    else
      return nav.extras.state[key];
  }

  constructor(private http: HttpClient,private route:ActivatedRoute,private router:Router,private recaptchaV3Service: ReCaptchaV3Service,private shareDataService:ShareDataServiceService, private location: Location) {
  }

  @Input() tender:Tender = new Tender();
  @Output() onClose:EventEmitter<any> = new EventEmitter<any>();

  regForm:FormGroup = new FormGroup({
    TenderId: new FormControl(0),
    TenderNumber: new FormControl(''),
    CompanyName:new FormControl('',[Validators.required,Validators.pattern("^([a-zA-Z0-9א-ת \"'/\\-_\\)\\(])*$")]),
    CompanyNumber: new FormControl('',[Validators.required,Validators.pattern("^\\d{0,9}$"),this.tz()]),
    FirstName: new FormControl('',[Validators.required,Validators.pattern("^([a-zA-Z0-9א-ת \"'/\\-_\\)\\(])*$")]),
    LastName: new FormControl('',[Validators.required,Validators.pattern("^([a-zA-Z0-9א-ת \"'/\\-_\\)\\(])*$")]),
    Address: new FormControl('',[Validators.required,Validators.pattern("^([a-zA-Z0-9א-ת \"'/\\-_\\)\\(])*$")]),
    Zip: new FormControl('',Validators.pattern("^\\d{0,7}$")),
    Phone: new FormControl('',[Validators.required,Validators.pattern("^0\\d{1,2}-?\\d{7}$")]),
    Email: new FormControl('',[Validators.required,Validators.email]),
    Notes: new FormControl(''),//,Validators.pattern("^([a-zA-Z0-9א-ת \"'/\\-_\\)\\(])*$")]),
    IsRegistered: new FormControl(null,Validators.required),
    CaptchaToken: new FormControl('')
  });

  @Output() onSelectTender:EventEmitter<SelectTenderEventProps> = new EventEmitter<SelectTenderEventProps>();

  ngOnInit(): void {
    if (!this.tender.TenderId) {
      const stateTender = this.getFromNavigaionState('tender');
      if (stateTender) {
        this.tender = stateTender;
        this.onLoadTender();
      }
      else {
        if (!this.route.snapshot || !this.route.snapshot.params || !this.route.snapshot.params['id']) return;
        const id: string = this.route.snapshot.params['id'];
        this.shareDataService.get({ url: environment.serviceUrl + '/api/tenders/' + id, method: 'get' }, 'tender_' + id)
          .then((res:any)=> {
            this.tender = res;
            this.onLoadTender();
          },err=>{
            console.log(err);
          });
      }
    }
    else {
      this.onLoadTender();
    }
  }

  onLoadTender():void{
      this.regForm.controls.TenderId.setValue(this.tender.TenderId);
      this.regForm.controls.TenderNumber.setValue(this.tender.MolsaTenderNumber);
      setTimeout(function(){window.scroll({top: 0,left: 0,behavior: 'smooth'});},1000);
  }

  lockBtn:boolean = false;
  onSubmit():void{
    console.log(this.regForm.value);
    if(this.regForm.invalid)
      return;
    this.recaptchaV3Service.execute('importantAction')
    .subscribe((token: any) => {
      this.regForm.controls.CaptchaToken.setValue(token);
      //this.regForm.controls.CompanyNumber.setValue(this.regForm.controls.CompanyNumber.value.toString());
      //this.regForm.controls.Zip.setValue(this.regForm.controls.Zip.value.toString());
      const sData = JSON.stringify(this.regForm.value);
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Strict-Transport-Security':'max-age=31536000; includeSubDomains'},
          body: sData,
          withCredentials:true
      };
      fetch(environment.serviceUrl+'/api/registration', requestOptions)
        .then(response => response.json())
        .then(res =>{
          if(res.Success==true){
            alert('בקשת הרישום נקלטה בהצלחה');
            this.lockBtn = true;
            this.close();
          }
          else
            alert(res.Error);
        })
        .catch(error => {
          console.error('There was an error!', error);
          alert('חלה תקלה, נא נסו מאוחר יותר.');
        });
    });
  }

  onCancel():void{
    this.location.back();
  }

  close():void{
    this.onClose.emit();
  }

 tz():ValidatorFn{
    return (control:AbstractControl):{[key:string]:any}| null=>{
      if(!control.value)
        return null;
      let sum:number=0;
      const arrTz = control.value.toString().split('').reverse().map((x:any)=>Number(x));
      for(var i=1;i<arrTz.length;i++){
        if(i%2==0)
          sum += arrTz[i];
        else{
          let a = arrTz[i]*2;
          if(a>9)
            a = Math.floor(a/10)+a%10;
          sum += a;
        } 
      }
      const mod:number = sum%10; 
      if(10 - (mod > 0 ? mod : 10) == arrTz[0])
        return null;
      return {tz:"יש להזין מספר חברה תקין כולל ספרת ביקורת"};
    }
  }
}
